import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { SellerPermission, StoreRoleView } from "@/lib/api/types";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";
import { invalidateSellerRoles } from "@/lib/query/core/invalidation";

type CreateStoreRoleInput = {
  storeSlug: string;
  key: string;
  name: string;
  description?: string;
  permissions: SellerPermission[];
};

export function useCreateStoreRoleMutation() {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    meta: { skipGlobalErrorToast: true },
    mutationFn: ({ storeSlug: _storeSlug, ...body }: CreateStoreRoleInput) =>
      apiJsonClient<StoreRoleView>(endpoints.seller.roles, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      }),
    onSuccess: async (_data, variables) => {
      await invalidateSellerRoles(queryClient, variables.storeSlug);
    },
  });

  return {
    mutateAsync: mutation.mutateAsync,
    isPending: mutation.isPending,
    error: mutation.error,
    reset: mutation.reset,
  };
}
